import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import AppraiserProfileEdit from "components/Appraiser/AppraiserProfileEdit";
import { AppInsightsTracker, MSpinner } from "components/Shared";
import {
  getAppraiserManagers,
  getAppraiserProfile,
  getCertificateList,
  getDesignationList,
  getStateList,
} from "actions/appraiser";
import { getAppraiserCounties } from "actions/appraiserCounties";
import { getUser } from "actions/user";

// This is a class-based component because the current
// version of hot reloading won't hot reload a stateless
// component at the top-level.
class AppraiserProfilePanel extends AppInsightsTracker {
  constructor(props) {
    super(props);
    this.displayName = "AppraiserProfilePanel";
  }

  UNSAFE_componentWillMount() {
    super.UNSAFE_componentWillMount();
    const { id, internetUserIdForPanel } = this.props;
    this.props.getAppraiserProfile(id);
    this.props.getUser(internetUserIdForPanel);
    this.props.getLists();
  }

  UNSAFE_componentWillUpdate(nextProps) {
    if (this.props.id != nextProps.id) {
      this.props.getAppraiserProfile(nextProps.id);
    }
    if (nextProps.internetUserIdForPanel && nextProps.internetUserIdForPanel != this.props.internetUserIdForPanel) {
      this.props.getUser(nextProps.internetUserIdForPanel);
    }
    if (this.props.internetUserId && this.props.internetUserId != nextProps.internetUserId) {
      this.props.getUser(nextProps.internetUserId);
    }
  }

  render() {
    const {
      fetchingAppraiserProfile, fetchingAppraiserManagers, fetchingCertificateList, fetchingDesignationList,
      fetchingStateList, isFetchingInternetUser, internetUser, fetchingAppraiserCounties, showHeaderButton
    } = this.props;

    let isLoading = fetchingAppraiserProfile
      || fetchingAppraiserManagers
      || fetchingCertificateList
      || fetchingDesignationList
      || fetchingStateList
      || isFetchingInternetUser
      || !internetUser
      || fetchingAppraiserCounties;

    if (isLoading) return (<MSpinner />);

    return (
      <AppraiserProfileEdit
        verticalDisplay={true}
        showHeaderButton={showHeaderButton}
      />);
  }
}

AppraiserProfilePanel.propTypes = {
  id: PropTypes.number.isRequired,
  internetUserIdForPanel: PropTypes.number.isRequired,
  fetchingAppraiserProfile: PropTypes.bool.isRequired,
  appraiserProfile: PropTypes.object.isRequired,
  fetchingAppraiserManagers: PropTypes.bool.isRequired,
  fetchingCertificateList: PropTypes.bool.isRequired,
  fetchingDesignationList: PropTypes.bool.isRequired,
  fetchingStateList: PropTypes.bool.isRequired,
  getAppraiserProfile: PropTypes.func.isRequired,
  isFetchingInternetUser: PropTypes.bool.isRequired,
  internetUser: PropTypes.object.isRequired,
  fetchingAppraiserCounties: PropTypes.bool.isRequired,
  getUser: PropTypes.func.isRequired,
  showHeaderButton: PropTypes.bool, // Set this to false to hide the "View Order Queue" header button in Appraisal Profile Edit
};

const mapStateToProps = (state) => ({
  appraiserProfile: state.appraiser.appraiserProfile,
  fetchingAppraiserProfile: state.appraiser.fetchingAppraiserProfile,
  fetchingAppraiserManagers: state.appraiser.fetchingAppraiserManagers,
  fetchingCertificateList: state.appraiser.fetchingCertificateList,
  fetchingDesignationList: state.appraiser.fetchingDesignationList,
  fetchingStateList: state.appraiser.fetchingStateList,
  isFetchingInternetUser: state.user.isFetchingInternetUser,
  internetUser: state.user.internetUser,
  fetchingAppraiserCounties: state.appraiser.fetchingCounties,
});

const mapDispatchToProps = (dispatch) => ({
  getAppraiserProfile(id) {
    dispatch(getAppraiserProfile(id));
    dispatch(getAppraiserCounties(id));
  },
  getLists() {
    dispatch(getAppraiserManagers());
    dispatch(getCertificateList());
    dispatch(getDesignationList());
    dispatch(getStateList());
  },
  getUser(internetUserId) {
    dispatch(getUser(internetUserId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AppraiserProfilePanel);
